import {
  LOAD_POPULAR_MOVIES,
  LOAD_POPULAR_MOVIES_SUCCESS,
  LOAD_POPULAR_MOVIES_ERROR
} from '../constants';

const initialState = [];

export default function popularMovies(state = initialState, action) {
  switch (action.type) {
    case LOAD_POPULAR_MOVIES_SUCCESS:
      return action.payload;
    case LOAD_POPULAR_MOVIES:
    case LOAD_POPULAR_MOVIES_ERROR:
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/popularMovies.js
 **/